(function () {
  'use strict';

  // Component used for booking item and booking item service item

  angular
    .module('app')
    .component('confirmBookingItemNotification', confirmBookingItemNotification());

  function confirmBookingItemNotification() {
    return {
      bindings: {
        notification: '<',
        bookingItem: '<',
        bookingItemServiceItem: '<',
        companyId: '<',
        bookingCurrency: '<',
        onBookingItemNotificationConfirmed: '&',
      },
      controller: ConfirmBookingItemNotificationComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/booking-item-notification/confirm-notification/' +
        'confirm-booking-item-notification.component.html',
    };
  }

  ConfirmBookingItemNotificationComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'moment',
    'BookingItemNotificationService',
  ];

  function ConfirmBookingItemNotificationComponent(
    config,
    UtilService,
    moment,
    BookingItemNotificationService
  ) {
    let vm = this;

    vm.UtilService = new UtilService(vm);
    vm.dateDisplay = config.DATE_DISPLAY;

    vm.totalCostEditable = false;

    // Methods
    vm.editNetCost = editNetCost;
    vm.selectRequestPayment = selectRequestPayment;
    vm.openPaymentDatePicker = openPaymentDatePicker;
    vm.confirmBookingNotification = confirmBookingNotification;

    vm.$onInit = function () {
      let totalCost = !vm.bookingItemServiceItem
        ? vm.bookingItem.total_cost
        : vm.bookingItemServiceItem.total_cost;

      // New notification
      if (!vm.notification) {
        vm.notification = {};
      }

      vm.notification.confirmed_by = '';
      vm.notification.confirmation_number = '';
      vm.notification.payment_net_cost = vm.notification.payment_net_cost || totalCost; // vm.UtilService.roundNum(
      vm.notification.payment_required = false;
      vm.notification.payment_percentage = 0;
      vm.notification.payment_date_limit = '';
      vm.notification.observations = '';

      vm.originalPaymentNetCost = angular.copy(vm.notification.payment_net_cost);

      setPaymentDatePicker();
    };

    function setPaymentDatePicker() {
      vm.paymentDateOptions = {
        singleDatePicker: true,
        minDate: moment(),
        maxDate: moment(vm.bookingItem.start_date),
        drops: 'up',
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'hide.daterangepicker': function () {
            // Clear invalid input
            if (
              vm.notification.payment_date_limit &&
              !vm.notification.payment_date_limit._isValid
            ) {
              vm.notification.payment_date_limit = '';
              vm.paymentDateOptions.minDate = moment();
            }
          },
        },
      };
    }

    function openPaymentDatePicker() {
      document.querySelector<HTMLElement>('input[name="payment_date_limit"]').focus(); // Not working if modal opens more than once
    }

    function editNetCost() {
      if (!vm.totalCostEditable) {
        vm.notification.payment_net_cost = vm.originalPaymentNetCost;
      }
    }

    function selectRequestPayment() {
      vm.notification.payment_percentage = 100;

      if (!vm.notification.payment_required) {
        vm.notification.payment_percentage = 0;
        vm.notification.payment_date_limit = '';
      }
    }

    function confirmBookingNotification(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        return;
      }

      if (vm.notification.payment_required) {
        vm.notification.payment_date_limit = vm.notification.payment_date_limit.format(); // important as saveBookingItemNotification uses UploadService // 2020-06-18T00:00:00-06:00
      }

      // console.log(vm.notification);
      // return;

      vm.notification.status = 'confirmed';

      let file = { file: vm.myFile };

      let params = {
        company_id: vm.companyId,
      };

      let bookingItemServiceItemId = vm.bookingItemServiceItem
        ? vm.bookingItemServiceItem.id
        : null;

      vm.sendingForm = true;
      BookingItemNotificationService.saveBookingItemNotification(
        vm.bookingItem.booking_id,
        vm.bookingItem.id,
        bookingItemServiceItemId,
        vm.notification,
        params,
        file
      ).then(function (response) {
        response = response.data;

        if (!response.errors) {
          let data = {
            notification: response.notification,
            booking_item_status: response.booking_item_status,
            booking_item_confirmation_status_mode: response.confirmation_status_mode,
            booking_status: response.booking_status,
            booking_item_service_item_status: null,
            booking_item_service_item_confirmation_status_mode: null,
          };

          if (vm.bookingItemServiceItem) {
            data.booking_item_service_item_status = response.booking_item_service_item_status;
            data.booking_item_service_item_confirmation_status_mode =
              response.confirmation_status_mode;
          }

          vm.onBookingItemNotificationConfirmed({ dataObj: data });

          vm.sendingForm = false;
        }
      });
    }
  }
})();
